import { ReactNode } from "react";

type Props = {
  children: ReactNode;
  right?: ReactNode;
};

export function SectionTitle({ children, right }: Props) {
  return (
    <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", padding: "20px 18px 8px" }}>
      <div className="tcg-section-title">{children}</div>
      {right}
    </div>
  );
}
